

const Data = [
   {
      id:1,
      category:"education",
      logo:"uil uil-graduation-cap",
      year:"2022-Present",
      title:"INPT School of Engineering",
      desc:"Advanced Software Engineering for Digital services ",

   },
    {
       id:2,
       category:"education",
       logo:"uil uil-graduation-cap",
       year:"2020-2022",
       title:"CPGE Med_Reda_Slaoui-Agadir",
       desc:"Physics & Industrial Science",

    },
    {
      id:3,
      category:"education",
      logo:"uil uil-graduation-cap",
      year:"2019-2020",
      title:"Baccalaureate",
      desc:"Math’s Science A",

   },
     {
        id:4,
        category:"experience",
        logo:"uil uil-bag-alt",
        year:"-",
        title:"No work experience for the moment",
        desc:"- ",
 
     },
]

export default Data